import React from 'react';

class MenuItem extends React.Component {

	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		//PASS THE CLICK UP THE CHAIN
		if(this.props.onClick) this.props.onClick(e);
	}

	render() {
		//Default render item will be text, but will check for icon and if icon is found insert that first.

		var content = [];

		if(this.props.icon)  {
			const iconJSX = (
				<div key='Icon' className='Menu-Icon'>
					<img src={this.props.icon} alt={'menu icon'}/>
				</div>

			);

			content.push(iconJSX);
		}

		if(this.props.label) {
			const labelJSX = (
				<div key='Label' className='Menu-Label'>
					{this.props.label}
				</div>
			);

			content.push(labelJSX);
		}

		return  (
			<div className='Menu-Item' data-id={this.props.dataID} onClick={this.onClick} >
				{content}
			</div>
		);
	}
}


export default MenuItem;